<template>

    <div class="articleSectionImage">
        <div :style="{'background-image': 'url(' + require('../assets/img/'+image) + ')', 'background-position': bgPos, 'background-size': bgSize}">
            <Caption v-if="caption" :title="caption"></Caption>
        </div>
    </div>

</template>

<script>
    import Caption from "./Caption";
    export default {
        name: 'ArticleSectionImage',
        components: {Caption},
        props: ['image', 'caption', 'bgPos', 'bgSize'],
        methods: {
            imgPath: function(img){
                return require('../assets/img/'+img);
            },
        }
    };
</script>

<style scoped lang="scss">
    .articleSectionImage{
        height: 100vh;
        padding: 0;
        margin:$G-default*2 0;

        @include breakpoint(xs){
            height: 50vh;
            padding: $G-default*2 0;
        }

        & > div{
            background-attachment: fixed;
            background-size: cover;
            background-position: center center;
            background-repeat: no-repeat;
            height: 100%;
            position: relative;
            @include breakpoint(xs){
                background-size: cover;
            }
        }

        &.noFixed {
            & > div {
                background-attachment: initial;
            }
        }

        .caption{
            position: absolute;
            bottom: $G-default;
            right: $G-default;
        }
        &.left_caption {
            .caption {
                right: auto;
                left: $G-default;
            }
        }
    }
</style>